var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "scartati" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "cyan headline" },
                [
                  _c("span", { staticClass: "white--text" }, [
                    _vm._v("Calciatori scartati"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "px-4 pt-4" }, [
                _vm._v(
                  "\n        I calciatori scartati non compaiono tra gli svincolati\n        (particolarmente utile se si usa l'estrazione casuale e non si vuole\n        che vengano estratti alcuni calciatori minori)\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center px-4 py-2" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "text--text mr-2", attrs: { small: "" } },
                    [_vm._v("info")]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n          I calciatori messi all'asta ma non assegnati a nessuno terminano\n          automaticamente tra gli scartati.\n        "
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _vm.classic
                    ? _c("select-ruoli-classic", {
                        model: {
                          value: _vm.selectedRuoloClassic,
                          callback: function ($$v) {
                            _vm.selectedRuoloClassic = $$v
                          },
                          expression: "selectedRuoloClassic",
                        },
                      })
                    : _c("select-ruoli-mantra", {
                        model: {
                          value: _vm.selectedRuoliMantra,
                          callback: function ($$v) {
                            _vm.selectedRuoliMantra = $$v
                          },
                          expression: "selectedRuoliMantra",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-4 pb-3" },
                [
                  _c("v-text-field", {
                    attrs: {
                      "prepend-icon": "search",
                      label: "Nome o squadra...",
                      color: "navy lighten-2",
                      "append-icon": _vm.nameFilter.length ? "cancel" : "",
                      "hide-details": "",
                    },
                    on: {
                      "click:append": function ($event) {
                        _vm.nameFilter = ""
                      },
                    },
                    model: {
                      value: _vm.nameFilter,
                      callback: function ($$v) {
                        _vm.nameFilter = $$v
                      },
                      expression: "nameFilter",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.scartatiFiltrati.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "v-list",
                        { staticClass: "scartati-list pa-0" },
                        _vm._l(_vm.scartatiFiltrati, function (scartato) {
                          return _c("calciatore", {
                            key: scartato.id,
                            attrs: {
                              id: scartato.id,
                              showButtonsScartaRiabilita: "",
                              disableSelection: "",
                              borderAsRuolo: "",
                              showQuotazione: "",
                              small: "",
                              scartato: true,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", { staticClass: "lista-vuota py-4" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.nameFilter.trim()
                            ? "Nessun calciatore scartato corrisponde alla ricerca in questo ruolo."
                            : "Nessun calciatore scartato in questo ruolo."
                        ) +
                        "\n      "
                    ),
                  ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", rounded: "" },
                      on: { click: _vm.manageAggiungiScartati },
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("fa-plus-circle"),
                      ]),
                      _vm._v("Aggiungi"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._.size(_vm.scartati) > 1
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "cyan white--text px-4",
                          attrs: { depressed: "", rounded: "" },
                          on: {
                            click: function ($event) {
                              return _vm.rimuoviScartati()
                            },
                          },
                        },
                        [_vm._v("\n          Riabilita tutti\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }